module.exports = {"1":"Positive","2":"Positive with corrections","3":"Negative"};